import React, { useState, useEffect, useCallback } from 'react'

// Deps
// import compareAsc from 'date-fns/compareAsc'

// Partials
import { Table, TR, TD } from 'views/shared/partials/table'
import Loader from 'views/shared/partials/loader'
import Dropdown from 'views/shared/partials/dropdown'
import Btn from 'views/shared/partials/btn'
import Link from 'views/shared/partials/link'
import { InputForm, FormInput } from 'views/shared/partials/forms'
import Pricebox from 'views/shared/partials/pricebox'
import Image from 'views/shared/partials/image'

// Utils
// import { openModal } from 'utils/modals';

// Services
import commerceServices from 'services/commerce'

const ProductList = ({query, onPaginate, ...props}) => {
	const [data, setData] = useState(false);

	const getData = useCallback(() => {
		setData(false);

		commerceServices.listProducts(query).then((payload) => {
			setData(payload);
		}).catch((error) => {
		});
	}, [query]);

	useEffect(() => {
		getData();	
	}, [query, getData])

	return (
		<section className={'portlet paymentlist ' + (props.className ? props.className : '')}>
			<div className="portlet-header">
				<strong className="portlet-title">Ürünler</strong>

				<div className="header-controls">
					<Btn
						white small wide
						icon="settings"
						tag="link"
						href="settings.productSettings">
						Entegrasyon Ayarları
					</Btn>
				</div>
			</div>

			<InputForm
				ignoreEmpty
				className="portlet-filters"
				onSubmit={props.onSearch}>
				<div className="filters-searchwrap">
					<FormInput
						className="lower"
						type="text"
						name="search_value"
						value={query.search_value}
						//onChange={(val) => { setFilters({...filters, search_value: val}) }}
						placeholder="Gruplarda Ara">
					</FormInput>
					<button
						type="submit"
						className="searchwrap-submit">
						<i className="icon-search"></i> ara
					</button>
				</div>
			</InputForm>

			<div className="portlet-section bottom loader-container">
				<Loader loading={!data} />
				{data &&
					<Table
						emptyMessage="Hiç ödeme bulunmuyor."
						className="products-table"
						pagination={data.pagination}
						onPaginate={onPaginate}
						heading={
							<React.Fragment>
								<th>Görsel</th>
								<th>Ürün</th>
								<th>Fiyat</th>
								<th></th>
							</React.Fragment>
						}>
						{data.products.map((product, nth) => (
							<TR key={nth} className="table-product">
								<TD className="product-image">
									<div className="table-imagewrap">
										<Image src={product.image_link} />
									</div>
								</TD>
								<TD className="product-description">
									<p className="table-subtitle">
										{product.brand}
									</p>
									<strong>
										{product.title}
									</strong>
									<p className="table-subtitle">
										{product.mpn}
									</p>
								</TD>
								<TD className="product-price">
									<Pricebox price={product.price} />
								</TD>
								<TD>
									<Dropdown
										text="İşlemler"
										icon="list">
										<Link
											href="productDetail"
											params={{ id: product.id }}>
											Detaya Git
										</Link>
										<Link
											className="blue"
											href={product.link}
											target="_blank"
											type="a">
											Ürün Sayfasına Git
										</Link>
									</Dropdown>
								</TD>
							</TR>
						))}
					</Table>
				}
			</div>
		</section>
	)
}

ProductList.defaultProps = {
	query: {},
	plain: false,
	initialFiltersOpen: false,
	title: 'Ürünler',
	onPaginate: () => {},
	onSearch: () => {},
}


export default ProductList;